var map = {
	"./de-DE.json": [
		2453,
		2
	],
	"./en-GB.json": [
		2454,
		3
	],
	"./en-US.json": [
		2455,
		4
	],
	"./es-419.json": [
		2456,
		5
	],
	"./es-ES.json": [
		2457,
		6
	],
	"./fr-CA.json": [
		2458,
		7
	],
	"./fr-FR.json": [
		2459,
		8
	],
	"./id-ID.json": [
		2460,
		9
	],
	"./it-IT.json": [
		2461,
		10
	],
	"./ja-JP.json": [
		2462,
		11
	],
	"./nl-NL.json": [
		2463,
		12
	],
	"./pt-BR.json": [
		2464,
		13
	],
	"./zh-CN.json": [
		2465,
		14
	],
	"./zh-Hans-CN.json": [
		2466,
		15
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1164;
module.exports = webpackAsyncContext;